export const newspinConstants = {
    NEWSPIN_SAVE_REQUEST: 'NEWSPIN_SAVE_REQUEST',
    NEWSPIN_SAVE_SUCCESS: 'NEWSPIN_SAVE_SUCCESS',
    NEWSPIN_SAVE_FAILURE: 'NEWSPIN_SAVE_FAILURE',
    NEWSPIN_SAVE_CLEAR: 'NEWSPIN_SAVE_CLEAR',
};
